import { supabase } from "../../lib/supabase";
import { mediaBucketName, safeMediaFileName } from "../media/mediaUtils";
import {
  compressImage,
  validateImageFile,
  type CompressedImageResult,
  IMAGE_COMPRESSION_CONFIG,
  isAlreadyOptimized,
} from "@vimos/api-client";

const DIRECTORY_STORAGE_PATH = (year: number) => `directorio/${year}`;

export async function uploadDirectoryImage(file: File): Promise<string> {
  const validation = validateImageFile(file);
  if (!validation.valid) throw new Error(validation.error);

  let fileToUpload = file;

  if (!isAlreadyOptimized(file)) {
    const result = await compressImage(file, {
      maxWidth: IMAGE_COMPRESSION_CONFIG.hero.width,
      maxHeight: IMAGE_COMPRESSION_CONFIG.hero.height,
      quality: IMAGE_COMPRESSION_CONFIG.hero.quality,
    });
    fileToUpload = result.file;
  }

  const year = new Date().getFullYear();
  const path = `${DIRECTORY_STORAGE_PATH(year)}/${safeMediaFileName(fileToUpload.name)}`;

  const { error } = await supabase.storage
    .from(mediaBucketName)
    .upload(path, fileToUpload, { cacheControl: "31536000", upsert: false });

  if (error) throw error;

  return supabase.storage.from(mediaBucketName).getPublicUrl(path).data.publicUrl;
}

export async function compressAndGetVariants(
  file: File,
): Promise<Record<string, CompressedImageResult>> {
  return {
    hero: await compressImage(file, {
      maxWidth: IMAGE_COMPRESSION_CONFIG.hero.width,
      maxHeight: IMAGE_COMPRESSION_CONFIG.hero.height,
      quality: IMAGE_COMPRESSION_CONFIG.hero.quality,
    }),
    card: await compressImage(file, {
      maxWidth: IMAGE_COMPRESSION_CONFIG.card.width,
      maxHeight: IMAGE_COMPRESSION_CONFIG.card.height,
      quality: IMAGE_COMPRESSION_CONFIG.card.quality,
    }),
    thumbnail: await compressImage(file, {
      maxWidth: IMAGE_COMPRESSION_CONFIG.thumbnail.width,
      maxHeight: IMAGE_COMPRESSION_CONFIG.thumbnail.height,
      quality: IMAGE_COMPRESSION_CONFIG.thumbnail.quality,
    }),
  };
}